import axios from "axios";
import { getBaseUrl } from "./AppConfig";
import { toast } from "react-toastify"

let isLoggingOut = false
const BASE_URL = getBaseUrl();

export const api = axios.create({
  baseURL: BASE_URL,
});

// Request Interceptor for dynamic headers
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const isFormData =
      config.data &&
      typeof config.data === "object" &&
      config.data.constructor?.name === "FormData";

    if (!config.headers["Content-Type"] && !isFormData) {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => {
    console.error("Request interceptor error:", {
      message: error.message,
      code: error.code,
      config: error.config,
    });
    return Promise.reject(error);
  }
);

// Response Interceptor for error logging
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("Response interceptor error:", {
      message: error.message,
      code: error.code,
      url: error.config?.url,
      method: error.config?.method,
      baseURL: error.config?.baseURL,
      status: error.response?.status,
      data: error.response?.data,
    });
    const { status } = error.response || {};
    const { url } = error.config || {};

    // Handle 401 - Token expired
    if (status === 401 && !url?.includes("/auth/")) {
      if (isLoggingOut) return;
      isLoggingOut = true;

      // Show expiry message
      toast.error("Your session has expired. Please login again.", {
        position: "top-right",
        autoClose: 5000,
      });

      // Clear localStorage
      localStorage.clear();

      // Navigate to login
      setTimeout(() => {
        window.location.href = "/";
        isLoggingOut = false;
      }, 1000);
    }

    // Handle 403 - Forbidden
    if (status === 403) {
      toast.warning(
        "Access denied. You don't have permission to perform this action.",
        {
          position: "top-right",
          autoClose: 3000,
        }
      );
    }

    // Handle 500 - Server Error
    if (status === 500) {
      toast.error("Server error occurred. Please try again later.", {
        position: "top-right",
        autoClose: 3000,
      });
    }
    return Promise.reject(error);
  }
);
